import React, {useState} from 'react'
import './Hud.scss'

const Hud = props => {
    const [open, setOpen] = useState(true);
    const handleMenuStepClick = (idx) => {
        props.onMenuStepClick(idx)
    }
    return (
        <div className={`Hud`}>
            <div className={`menu-body ${open ? 'open' : 'closed'}`}>
                <div className={`buttons`}>
                    <div className={`menu-button`} onClick={()=> props.setIntroOpen(true)}>Task Goal</div>
                    <div className={`menu-button`}>Demo Step</div>
                    <div className={`menu-button`}>Demo All</div>
                </div>

                <div className={`steps-nav`}>
                    <div className={`label`}>Steps</div>
                    <div className={`steps`}>
                        {
                           props.steps.map((step, idx) => {
                                return <div 
                                className={`step ${idx < props.stepIndex ? 'past' : ''} ${idx === props.stepIndex ? 'current' : ''}`} 
                                onClick={()=>handleMenuStepClick(idx)}
                                key={`step-menu-${idx}`}>


                                    {
                                        idx <= props.stepIndex && 
                                        <div className={`step-rollover-hitbox`}>
                                            <div className={`step-rollover`} dangerouslySetInnerHTML={{__html:step.stepRollover}}></div>
                                        </div>
                                    }
                                   
                                    <div className={`text`}>
                                        {idx + 1}
                                    </div>

                                    {
                                        idx === props.stepIndex && 
                                        <div className={`hint-hover`}>Hint
                                        <div className={`hint-breakout orange-gradient`} dangerouslySetInnerHTML={{__html:props.hintHTML}}></div></div>
                                    }
                                </div>
                           })
                        }

                    </div>
                </div>
                <div className={`bottom-buttons`}>
                    <div className={`bottom-button`}><div className={`icon back`}></div><div className={`text`}>Menu</div></div>
                    <div className={`bottom-button`} onClick={()=>props.setHelpOpen(true)}><div className={`icon info`}></div><div className={`text`}>Info</div></div>
                </div>
                <div className={`hint`}></div>
                <div className={`tab`} onClick={()=>setOpen(!open)}>{`${open ? 'Hide' : 'Show'}`}</div>
            </div>
        </div>
    )
}

export default Hud